export const sourceList = ['ALL', 'EMA', 'CBER', 'CDER'];

export const qcStatusList = ['ALL', 'In progress', 'Escalate', 'ToQc', 'Qced', 'Qced w/o match'];

export const regionSourceMapping: {
  [key: string]: string;
} = {
  cber: 'us',
  cder: 'us',
  ema: 'eu'
};
